(function () {
  const Core = window.RB.Core;
  const Flow = window.RB.Flow;
  const FX = window.RB.FX;

  function controlsTaggedUnit(state, p, tag, except) {
    return Core.boardObjs(state, function (o, iid) {
      return iid !== except && o.controller === p && Core.isType(state, iid, "unit") && Core.hasTag(state, iid, tag);
    }).length > 0;
  }

  const boundTargets = function (ctx, cond) {
    return (ctx.item && ctx.item.targets[cond.bind]) || [];
  };

  const staticItem = function (ctx, state0) {
    if (ctx.item) return ctx.item;
    const o = state0 && state0.objs ? state0.objs[ctx.iid] : null;
    let bf = o && o.loc && o.loc.t === "bf" ? o.loc.iid : null;
    if (!bf && state0 && (state0.battlefields || []).indexOf(ctx.iid) >= 0) bf = ctx.iid;
    return {
      controller: ctx.p, source: ctx.iid, iid: ctx.iid,
      targets: {}, vars: {}, ctx: bf ? { bf: bf } : {},
    };
  };

  const specCount = function (state, cond, ctx) {
    return RB.Play.candidates(state, cond.spec || {}, staticItem(ctx, state)).length;
  };

  const compare = function (v, cond) {
    const cmp = cond.cmp || "atLeast";
    const n = cond.n === undefined ? 1 : cond.n;
    if (cmp === "atMost") return v <= n;
    if (cmp === "exactly") return v === n;
    return v >= n;
  };

  const COND_KEYS = {
    and(state, cond, ctx) { return (cond.conds || []).every(function (c2) { return FX.evalCond(state, c2, ctx); }); },
    or(state, cond, ctx) { return (cond.conds || []).some(function (c2) { return FX.evalCond(state, c2, ctx); }); },
    not(state, cond, ctx) { return !FX.evalCond(state, cond.cond, ctx); },
    always() { return true; },
    count(state, cond, ctx) { return compare(specCount(state, cond, ctx), cond); },
    totalMight(state, cond, ctx) {
      let v = 0;
      for (const iid of RB.Play.candidates(state, cond.spec || {}, staticItem(ctx, state))) {
        const m = Core.effMight(state, iid);
        if (m !== null) v += m;
      }
      return compare(v, cond);
    },
    selfTag(state, cond, ctx) { return Core.hasTag(state, ctx.iid, cond.tag); },
    selfType(state, cond, ctx) { return Core.isType(state, ctx.iid, cond.type); },
    selfToken(state, cond, ctx) { return !!(state.objs[ctx.iid] || {}).token; },
    selfName(state, cond, ctx) { return Core.name(state, ctx.iid) === cond.name; },
    selfKw(state, cond, ctx) { return Core.hasKw(state, ctx.iid, cond.kw); },
    selfMightAtLeast(state, cond, ctx) {
      const m = Core.effMight(state, ctx.iid);
      return m !== null && m >= cond.n;
    },
    selfMightAtMost(state, cond, ctx) {
      const m = Core.effMight(state, ctx.iid);
      return m !== null && m <= cond.n;
    },
    selfDamagedThisTurn(state, cond, ctx) {
      return !!(state.turn.damaged && state.turn.damaged[ctx.iid]);
    },
    selfAtEvBf(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!(o && o.loc && o.loc.t === "bf" && o.loc.iid === ctx.ev.bf);
    },
    selfDamaged(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!(o && o.damage && o.damage.length);
    },
    selfStunned(state, cond, ctx) { return !!(state.objs[ctx.iid] || {}).stunned; },
    selfAtBase(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!(o && o.loc && o.loc.t === "base");
    },
    selfAttacking(state, cond, ctx) { return (state.objs[ctx.iid] || {}).designation === "attacker"; },
    selfDefending(state, cond, ctx) { return (state.objs[ctx.iid] || {}).designation === "defender"; },
    targetTag(state, cond, ctx) {
      return boundTargets(ctx, cond).some(function (t) { return Core.hasTag(state, t, cond.tag); });
    },
    targetType(state, cond, ctx) {
      return boundTargets(ctx, cond).some(function (t) { return Core.isType(state, t, cond.type); });
    },
    targetEmpowered(state, cond, ctx) {
      return boundTargets(ctx, cond).some(function (t) { return !!(state.objs[t] || {}).empowered; });
    },
    targetMightAtMost(state, cond, ctx) {
      return boundTargets(ctx, cond).some(function (t) {
        const m = Core.effMight(state, t);
        return m !== null && m <= cond.n;
      });
    },
    targetAttacking(state, cond, ctx) {
      return boundTargets(ctx, cond).some(function (t) { return (state.objs[t] || {}).designation === "attacker"; });
    },
    targetDefending(state, cond, ctx) {
      return boundTargets(ctx, cond).some(function (t) { return (state.objs[t] || {}).designation === "defender"; });
    },
    targetKw(state, cond, ctx) {
      return boundTargets(ctx, cond).some(function (t) { return Core.hasKw(state, t, cond.kw); });
    },
    evSnapshotSelfLoc(state, cond, ctx) {
      const snap = ctx.ev.snapshot;
      const o = state.objs[ctx.iid];
      return !!(snap && o && snap.loc && o.loc && Core.sameLoc(snap.loc, o.loc));
    },
    targetAtBf(state, cond, ctx) {
      return boundTargets(ctx, cond).some(function (t) {
        const o = state.objs[t];
        return !!(o && o.loc && o.loc.t === "bf");
      });
    },
    nameInTrash(state, cond, ctx) {
      const c = Core.card(state, ctx.iid);
      if (!c) return false;
      const name = cond.name || c.name;
      let v = 0;
      for (const tIid of state.players[ctx.p].trash) {
        const tc = Core.card(state, tIid);
        if (tc && tc.name === name) v++;
      }
      return compare(v, cond);
    },
    unitDiedThisTurn(state, cond, ctx) {
      const f = state.turnFacts;
      if (cond.who === "friendly") return !!f.players[ctx.p].unitDied;
      if (cond.who === "enemy") return !!f.players[Core.otherPlayer(ctx.p)].unitDied;
      return !!(f.players[0].unitDied || f.players[1].unitDied);
    },
    gainedXpThisTurn(state, cond, ctx) { return !!state.turnFacts.players[ctx.p].xpGained; },
    spellSpentAtLeast(state, cond, ctx) {
      return (state.turnFacts.players[ctx.p].maxSpellEnergy || 0) >= (cond.n === undefined ? 4 : cond.n);
    },
    lastSpellSpentAtLeast(state, cond, ctx) {
      return (state.turnFacts.players[ctx.p].lastSpellEnergy || 0) >= (cond.n === undefined ? 1 : cond.n);
    },
    spentPowerAtLeast(state, cond, ctx) {
      return (state.turnFacts.players[ctx.p].spentPower || 0) >= (cond.n === undefined ? 1 : cond.n);
    },
    scoreWithin(state, cond, ctx) {
      const who = cond.who === "opponent" ? Core.otherPlayer(ctx.p) : ctx.p;
      return state.players[who].points >= Core.victoryScore(state) - (cond.within === undefined ? 3 : cond.within);
    },
    oppStunnedUnit(state, cond, ctx) {
      const opp2 = Core.otherPlayer(ctx.p);
      return Core.boardObjs(state).some(function (i2) {
        const o = state.objs[i2];
        return o.controller === opp2 && o.stunned && Core.isType(state, i2, "unit");
      });
    },
    runesFewerThanOpp(state, cond, ctx) {
      return Core.runesOf(state, ctx.p).length < Core.runesOf(state, Core.otherPlayer(ctx.p)).length;
    },
    phase(state, cond, ctx) { return state.turn.phase === cond.phase; },
    turnAtLeast(state, cond, ctx) { return state.turn.num >= cond.n; },
    myTurn(state, cond, ctx) { return state.turn.player === ctx.p; },
    turnFact(state, cond, ctx) {
      const who = cond.who === "opponent" ? Core.otherPlayer(ctx.p) : ctx.p;
      return compare(state.turnFacts.players[who][cond.key] || 0, cond);
    },
    fromHand(state, cond, ctx) { return (ctx.item.fromZone || "hand") === "hand" && !ctx.item.fromFacedown; },
    fromFacedown(state, cond, ctx) { return !!(ctx.item.fromFacedown || (ctx.item.ctx && ctx.item.ctx.fromFacedown)); },
    legion(state, cond, ctx) { return state.turnFacts.players[ctx.p].played >= (cond.n || 2); },
    playedSpellThisTurn(state, cond, ctx) { return state.turnFacts.players[ctx.p].spells >= 1; },
    targetDead(state, cond, ctx) {
      const arr = boundTargets(ctx, cond);
      if (!arr.length) return false;
      return arr.every(function (t) {
        const o = state.objs[t];
        if (!o || o.zone !== "board") return true;
        return Core.isType(state, t, "unit") && Core.lethal(state, t);
      });
    },
    xp(state, cond, ctx) { return state.players[ctx.p].xp >= (cond.n === undefined ? 1 : cond.n); },
    targetsChosen(state, cond, ctx) { return boundTargets(ctx, cond).length > 0; },
    controlsBf(state, cond, ctx) {
      return state.battlefields.some(function (b) { return state.objs[b].controller === ctx.p; });
    },
    handMax(state, cond, ctx) { return state.players[ctx.p].hand.length <= cond.n; },
    runeDeckAtLeast(state, cond, ctx) { return state.players[ctx.p].runeDeck.length >= (cond.n || 1); },
    aloneAt(state, cond, ctx) {
      const arr = boundTargets(ctx, cond);
      if (!arr.length) return false;
      const o = state.objs[arr[0]];
      if (!o || o.zone !== "board" || !o.loc) return false;
      return Core.unitsAt(state, o.loc, function (u) { return u.controller === o.controller; }).length === 1;
    },
    targetMightAtLeast(state, cond, ctx) {
      const arr = boundTargets(ctx, cond);
      if (!arr.length) return false;
      const m = Core.effMight(state, arr[0]);
      return m !== null && m >= cond.n;
    },
    controlsTag(state, cond, ctx) { return controlsTaggedUnit(state, ctx.p, cond.tag, null); },
    controlsTagOther(state, cond, ctx) { return controlsTaggedUnit(state, ctx.p, cond.tag, ctx.iid); },
    targetStunned(state, cond, ctx) {
      const arr = boundTargets(ctx, cond);
      return arr.length > 0 && !!state.objs[arr[0]].stunned;
    },
    ctxBf(state, cond, ctx) { return !!(ctx.item.ctx && ctx.item.ctx.bf); },
    varEq(state, cond, ctx) { return (ctx.item.vars[cond.key] !== undefined ? ctx.item.vars[cond.key] : null) === cond.value; },
    varAtLeast(state, cond, ctx) { return (ctx.item.vars[cond.key] || 0) >= cond.n; },
    channeledLessThan(state, cond, ctx) { return (ctx.item.vars.channeled || 0) < cond.n; },
    runesMax(state, cond, ctx) { return Core.runesOf(state, ctx.p).length <= cond.n; },
    unitsHereAtLeast(state, cond, ctx) {
      const bf = ctx.item.ctx && ctx.item.ctx.bf;
      if (!bf) return false;
      return Core.unitsAt(state, { t: "bf", iid: bf }, function (u) { return u.controller === ctx.p; }).length >= cond.n;
    },
    gearAttachedThisTurn(state, cond, ctx) {
      const g = ctx.via && state.objs[ctx.via];
      return !!(g && g.flags.attachedTurn === state.turn.num);
    },
    atBfWithOtherFriendly(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      if (!o || !o.loc || o.loc.t !== "bf") return false;
      const others = Core.unitsAt(state, o.loc, function (u) { return u.controller === o.controller && u.iid !== ctx.iid; });
      return others.length === (cond.n || 1);
    },
    empoweredTimes(state, cond, ctx) {
      return compare((state.objs[ctx.iid] || {}).empowerCount || 0, cond);
    },
    selfEmpowered(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!(o && o.empowered);
    },
    oppControlsBf(state, cond, ctx) {
      const opp = Core.otherPlayer(ctx.p);
      return state.battlefields.some(function (b) { return state.objs[b].controller === opp; });
    },
    oppNearWin(state, cond, ctx) {
      const opp = Core.otherPlayer(ctx.p);
      return state.players[opp].points >= Core.victoryScore(state) - (cond.n || 3);
    },
    targetStunnedEnemy(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!(o && o.stunned);
    },
    movedAtLeast(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!o && (o.flags.movedThisTurn || 0) >= (cond.n || 2);
    },
    evToBf(state, cond, ctx) { return !!(ctx.ev && ctx.ev.to && ctx.ev.to.t === "bf"); },
    evFromBf(state, cond, ctx) { return !!(ctx.ev && ctx.ev.from && ctx.ev.from.t === "bf"); },
    evSnapshotUnit(state, cond, ctx) { return !!(ctx.ev && ctx.ev.snapshot && ctx.ev.snapshot.isUnit); },
    excessDamageAtLeast(state, cond, ctx) {
      const sd = state.showdown;
      return !!(sd && sd.excess && ctx.ev && ctx.ev.player !== undefined && (sd.excess[ctx.ev.player] || 0) >= (cond.n || 1));
    },
    evYou(state, cond, ctx) { return ctx.ev.player === ctx.p; },
    evHostSelf(state, cond, ctx) { return ctx.ev.host === ctx.iid; },
    evTag(state, cond, ctx) { return Core.hasTag(state, ctx.ev.iid, cond.tag); },
    evControllerYou(state, cond, ctx) { return ctx.ev.controller === ctx.p; },
    evAbilitySourceType(state, cond, ctx) {
      return ctx.ev.kind === "ability" && !!ctx.ev.source && Core.isType(state, ctx.ev.source, cond.type);
    },
    evChosenBySpell(state, cond, ctx) {
      if ((ctx.ev.targets || []).indexOf(ctx.iid) < 0) return false;
      if (cond.byYou && ctx.ev.by !== ctx.p) return false;
      return (state.chain || []).some(function (it) {
        if (it.kind !== "spell" || it.controller !== ctx.ev.by) return false;
        for (const b in it.targets || {}) if ((it.targets[b] || []).indexOf(ctx.iid) >= 0) return true;
        return false;
      });
    },
    evTargetsFriendlyUnit(state, cond, ctx) {
      if (cond.byYou && ctx.ev.by !== ctx.p) return false;
      return (ctx.ev.targets || []).some(function (t) {
        const o = state.objs[t];
        return !!(o && o.zone === "board" && o.controller === ctx.p && Core.isType(state, t, "unit"));
      });
    },
    evIsEquipment(state, cond, ctx) {
      const sc = ctx.ev && ctx.ev.iid ? RB.Scripts.forCard(state, ctx.ev.iid) : null;
      return !!(sc && (sc.abilities || []).some(function (ab) { return ab.label === "Equip"; }));
    },
    evTargetsSelf(state, cond, ctx) {
      if ((ctx.ev.targets || []).indexOf(ctx.iid) < 0) return false;
      return cond.byYou ? ctx.ev.by === ctx.p : true;
    },
    ownTurnsTaken(state, cond, ctx) {
      return compare(state.players[ctx.p].turnsTaken || 0, cond);
    },
    evOther(state, cond, ctx) { return ctx.ev.iid !== ctx.iid; },
    evType(state, cond, ctx) { return Core.isType(state, ctx.ev.iid, cond.type); },
    evCardEnergyAtLeast(state, cond, ctx) { return ((Core.card(state, ctx.ev.iid) || {}).energy || 0) >= cond.n; },
    evFromFacedown(state, cond, ctx) { return !!ctx.ev.fromFacedown; },
    evNotFromHand(state, cond, ctx) {
      const o = ctx.ev.iid && state.objs[ctx.ev.iid];
      return !!(o && (o.playFromZone || "hand") !== "hand");
    },
    evAbilityEnergyAtLeast(state, cond, ctx) {
      if (ctx.ev.kind !== "ability") return false;
      const it = RB.Play.itemById(state, ctx.ev.id);
      return !!it && ((it.cost && it.cost.energy) || 0) >= cond.n;
    },
    evEnemy(state, cond, ctx) {
      const u = state.objs[ctx.ev.iid];
      return !!u && u.controller !== ctx.p;
    },
    evFriendly(state, cond, ctx) {
      const u = state.objs[ctx.ev.iid];
      return !!u && u.controller === ctx.p;
    },
    evSnapshotSelf(state, cond, ctx) { return (ctx.ev.snapshot || {}).iid === ctx.iid; },
    evSelfOrTrashed(state, cond, ctx) { return ctx.ev.trashIid === ctx.iid || ctx.ev.iid === ctx.iid; },
    evFromSelfBf(state, cond, ctx) { return !!(ctx.ev.from && ctx.ev.from.t === "bf" && ctx.ev.from.iid === ctx.iid); },
    evAtBf(state, cond, ctx) {
      const o = ctx.ev.iid && state.objs[ctx.ev.iid];
      if (o && o.loc) return o.loc.t === "bf";
      return !!(ctx.ev.loc && ctx.ev.loc.t === "bf");
    },
    evAtBase(state, cond, ctx) {
      const o = ctx.ev.iid && state.objs[ctx.ev.iid];
      if (o && o.loc) return o.loc.t === "base";
      return !!(ctx.ev.loc && ctx.ev.loc.t === "base");
    },
    evToken(state, cond, ctx) { return !!(state.objs[ctx.ev.iid] || {}).token; },
    evAtSelfBf(state, cond, ctx) {
      const isBf = (state.battlefields || []).indexOf(ctx.iid) >= 0;
      const here = isBf ? { t: "bf", iid: ctx.iid } : (state.objs[ctx.iid] || {}).loc;
      if (!here) return false;
      if (ctx.ev.loc) return Core.sameLoc(ctx.ev.loc, here);
      const eo = ctx.ev.iid && state.objs[ctx.ev.iid];
      return !!(eo && eo.loc && Core.sameLoc(eo.loc, here));
    },
    scoredHereThisTurn(state, cond, ctx) {
      const map = state.turn[cond.how === "conquer" ? "conqueredBfs" : "heldBfs"] || {};
      const who = cond.who === "opponent" ? Core.otherPlayer(ctx.p) : ctx.p;
      return map[ctx.iid] === who;
    },
    evBfMine(state, cond, ctx) { return !!state.objs[ctx.ev.bf] && state.objs[ctx.ev.bf].controller === ctx.p; },
    turnMax(state, cond, ctx) { return state.turn.num <= cond.n; },
    notMyTurn(state, cond, ctx) { return state.turn.player !== ctx.p; },
    playedExactly(state, cond, ctx) { return state.turnFacts.players[ctx.p].played === cond.n; },
    selfAtBf(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!(o && o.loc && o.loc.t === "bf");
    },
    selfReady(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!(o && o.ready);
    },
    selfHasBuff(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!(o && o.buffs > 0);
    },
    movedExactly(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!o && (o.flags.movedThisTurn || 0) === cond.n;
    },
    showdownActive(state, cond, ctx) { return !!state.showdown; },
    showdownDefender(state, cond, ctx) { return !!(state.showdown && state.showdown.defender === ctx.p); },
    showdownHere(state, cond, ctx) {
      if (!state.showdown) return false;
      if ((state.battlefields || []).indexOf(ctx.iid) >= 0) return state.showdown.bf === ctx.iid;
      const o = state.objs[ctx.iid];
      return !!(o && o.loc && o.loc.t === "bf" && o.loc.iid === state.showdown.bf);
    },
    showdownHereDefending(state, cond, ctx) {
      return !!(state.showdown && state.showdown.bf === ctx.iid && state.showdown.defender === ctx.p);
    },
    discardedThisTurn(state, cond, ctx) { return state.turnFacts.players[ctx.p].discarded; },
    runesAtLeast(state, cond, ctx) { return Core.runesOf(state, ctx.p).length >= cond.n; },
    controlsHiddenBf(state, cond, ctx) {
      return state.battlefields.some(function (b) {
        const bf = state.objs[b];
        return Flow.hiddenAt(state, b).length > 0 && bf.controller === ctx.p;
      });
    },
    inCombat(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!(o && (o.designation === "attacker" || o.designation === "defender"));
    },
    defending(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!(o && o.designation === "defender");
    },
    aloneHere(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      if (!o || !o.loc) return false;
      return Core.unitsAt(state, o.loc, function (u) { return u.controller === o.controller; }).length === 1;
    },
    selfInZone(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      return !!o && o.zone === cond.zone;
    },
    enemyReadyUnitHere(state, cond, ctx) {
      const o = state.objs[ctx.iid];
      if (!o || !o.loc) return false;
      return Core.unitsAt(state, o.loc, function (u) { return u.controller !== o.controller && u.ready; }).length > 0;
    },
    evBfUnitsAtLeast(state, cond, ctx) {
      return Core.unitsAt(state, { t: "bf", iid: ctx.ev.bf }, function (u) { return u.controller === ctx.ev.player; }).length >= cond.n;
    },
    evAloneAtEvBf(state, cond, ctx) {
      const u = state.objs[ctx.ev.iid];
      if (!u) return false;
      return Core.unitsAt(state, { t: "bf", iid: ctx.ev.bf }, function (x) { return x.controller === u.controller; }).length === 1;
    },
    evToNotSelfLoc(state, cond, ctx) {
      const me = state.objs[ctx.iid];
      return !(me && me.loc && ctx.ev.to && Core.sameLoc(me.loc, ctx.ev.to));
    },
    evFromSelfLoc(state, cond, ctx) {
      const me = state.objs[ctx.iid];
      return !!(me && Core.sameLoc(ctx.ev.from, me.loc));
    },
    evMightAtLeast(state, cond, ctx) {
      const m = Core.effMight(state, ctx.ev.iid);
      return m !== null && m >= cond.n;
    },
    evSnapshotFriendly(state, cond, ctx) { return !!(ctx.ev.snapshot && ctx.ev.snapshot.controller === ctx.p); },
    evSnapshotEnemy(state, cond, ctx) { return !!(ctx.ev.snapshot && ctx.ev.snapshot.controller !== ctx.p); },
    evSnapshotOther(state, cond, ctx) { return !!(ctx.ev.snapshot && ctx.ev.snapshot.iid !== ctx.iid); },
    evSnapshotBuffed(state, cond, ctx) { return !!(ctx.ev.snapshot && ctx.ev.snapshot.buffs > 0); },
    evSnapshotStunned(state, cond, ctx) { return !!(ctx.ev.snapshot && ctx.ev.snapshot.stunned === true); },
    evSnapshotNotTag(state, cond, ctx) {
      const s = ctx.ev.snapshot;
      return !!s && (s.tags || []).indexOf(cond.tag) < 0;
    },
    evKilledByMe(state, cond, ctx) { return !!ctx.ev.attribution && ctx.ev.attribution.by === ctx.p; },
    evKilledByMySpell(state, cond, ctx) {
      const att = ctx.ev.attribution || {};
      return att.bySpell === true && att.by === ctx.p;
    },
    evPlayerChampionInTrash(state, cond, ctx) {
      const player = state.players[ctx.ev.player];
      if (player.champion.length) return false;
      return player.trash.some(function (t) { return (Core.card(state, t) || {}).id === player.chosenChampion; });
    },
    evTargetsUnitHereByActor(state, cond, ctx) {
      return (ctx.ev.targets || []).some(function (t) {
        const o = state.objs[t];
        return !!(o && o.loc && o.loc.t === "bf" && o.loc.iid === ctx.iid && o.controller === ctx.ev.by);
      });
    },
    notConqueredThisTurn(state, cond, ctx) {
      const o2 = state.objs[ctx.iid];
      return !!o2 && o2.flags.conqueredTurn !== state.turn.num;
    },
  };

  Object.assign(FX, {
    COND_KEYS: COND_KEYS,

    evalCond(state, cond, ctx) {
      if (!cond) return true;
      const fn = COND_KEYS[cond.k];
      if (!fn) throw new Error("unknown condition: " + JSON.stringify(cond));
      return fn(state, cond, ctx);
    },
  });
})();
